import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const GridViewIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M3.33 9.17V3.33h5.84v5.84zm0 7.5v-5.84h5.84v5.84zm7.5-7.5V3.33h5.84v5.84zm0 7.5v-5.84h5.84v5.84zM4.17 8.33h4.16V4.17H4.17zm7.5 0h4.16V4.17h-4.16zm0 7.5h4.16v-4.16h-4.16zm-7.5 0h4.16v-4.16H4.17z"
            />
        </svg>
    </IconWrapper>
));
